var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_60_9",
    "data-name": "Componente 60 \\u2013 9",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_271",
    "data-name": "Rect\\xE1ngulo 271",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "call_split_FILL0_wght300_GRAD0_opsz40",
    d: "M182.346-776v4.75a1.131,1.131,0,0,1-.339.836,1.144,1.144,0,0,1-.84.337,1.123,1.123,0,0,1-.834-.337,1.142,1.142,0,0,1-.333-.836v-7.287a1.412,1.412,0,0,1,.42-1.04,1.413,1.413,0,0,1,1.04-.42h7.3a1.137,1.137,0,0,1,.83.339,1.134,1.134,0,0,1,.343.84,1.113,1.113,0,0,1-.343.834,1.148,1.148,0,0,1-.83.333h-4.743l10.331,10.331a3.056,3.056,0,0,1,.632.934,2.794,2.794,0,0,1,.243,1.149v12.068a1.131,1.131,0,0,1-.339.836,1.144,1.144,0,0,1-.84.337,1.123,1.123,0,0,1-.834-.337,1.143,1.143,0,0,1-.333-.836v-12.077a.524.524,0,0,0-.042-.206.714.714,0,0,0-.12-.188Zm23.31,0-6.818,6.8a1.151,1.151,0,0,1-.821.356,1.1,1.1,0,0,1-.834-.356,1.165,1.165,0,0,1-.359-.841,1.079,1.079,0,0,1,.365-.817l6.8-6.789h-4.731a1.132,1.132,0,0,1-.835-.339,1.144,1.144,0,0,1-.337-.84,1.123,1.123,0,0,1,.337-.834,1.142,1.142,0,0,1,.835-.333h7.287a1.413,1.413,0,0,1,1.04.42,1.412,1.412,0,0,1,.42,1.04v7.287a1.131,1.131,0,0,1-.339.836,1.144,1.144,0,0,1-.84.337,1.123,1.123,0,0,1-.834-.337,1.142,1.142,0,0,1-.333-.836Z",
    transform: "translate(-178 781.998)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanales);
export default __webpack_public_path__ + "static/media/canales.79e5a3562a27c4e444b3cc47e544791c.svg";
export { ForwardRef as ReactComponent };